import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { toast } from 'react-toastify';
import API from '../services/api';
import './SoftwareRatingModal.css';

const SoftwareRatingModal = ({ show, onClose, onRatingSubmitted }) => {
 const [rating, setRating] = useState(0);
 const [hoverRating, setHoverRating] = useState(0);
 const [feedback, setFeedback] = useState('');
 const [isSubmitting, setIsSubmitting] = useState(false);

 const handleSubmit = async (e) => {
 e.preventDefault();

 if (rating === 0) {
 toast.warning('Vui lòng chọn số sao đánh giá!');
 return;
 }

 setIsSubmitting(true);

 try {
 await API.post('/software-rating', {
 rating,
 feedback: feedback.trim()
 });

 toast.success('Cảm ơn bạn đã đánh giá phần mềm!');

 // Reset form
 setRating(0);
 setFeedback('');

 // Callback to parent
 if (onRatingSubmitted) {
 onRatingSubmitted();
 }

 // Close modal
 onClose();
 } catch (error) {
 console.error('Error submitting rating:', error);
 toast.error(error.response?.data?.message || 'Lỗi khi gửi đánh giá. Vui lòng thử lại!');
 } finally {
 setIsSubmitting(false);
 }
 };

 const renderStars = () => {
 return [1, 2, 3, 4, 5].map((star) => {
 const isFilled = star <= (hoverRating || rating);
 return (
 <span
 key={star}
 className={`star-icon ${isFilled ? 'filled' : ''}`}
 onClick={() => setRating(star)}
 onMouseEnter={() => setHoverRating(star)}
 onMouseLeave={() => setHoverRating(0)}
 >
 {isFilled ? <FaStar /> : <FaRegStar />}
 </span>
 );
 });
 };

 const getRatingLabel = () => {
 const labels = {
 1: 'Rất không hài lòng',
 2: 'Không hài lòng',
 3: 'Bình thường',
 4: 'Hài lòng',
 5: 'Rất hài lòng'
 };
 return labels[hoverRating || rating] || 'Chọn đánh giá của bạn';
 };

 return (
 <Modal
 show={show}
 onHide={onClose}
 centered
 backdrop="static"
 keyboard={false}
 className="software-rating-modal"
 size="sm"
 >
 <Modal.Header className="border-0 pb-0">
 <Modal.Title className="w-100 text-center">
 <h5 className="mb-1">Đánh giá phần mềm</h5>
 </Modal.Title>
 </Modal.Header>

 <Modal.Body className="pt-2 pb-3">
 <Form onSubmit={handleSubmit}>
 {/* Star Rating */}
 <div className="rating-section text-center mb-3">
 <div className="stars-container mb-2">
 {renderStars()}
 </div>
 <div className="rating-label" style={{ fontSize: '0.9rem' }}>
 <strong>{getRatingLabel()}</strong>
 </div>
 </div>

 {/* Feedback (Optional) */}
 <Form.Group className="mb-3">
 <Form.Label className="small mb-1">
 Ý kiến đóng góp <span className="text-muted">(không bắt buộc)</span>
 </Form.Label>
 <Form.Control
 as="textarea"
 rows={3}
 placeholder="Chia sẻ trải nghiệm của bạn..."
 value={feedback}
 onChange={(e) => setFeedback(e.target.value)}
 maxLength={500}
 disabled={isSubmitting}
 style={{ fontSize: '0.9rem' }}
 />
 <Form.Text className="text-muted small">
 {feedback.length}/500 ký tự
 </Form.Text>
 </Form.Group>

 {/* Action Buttons */}
 <div className="d-flex gap-2 justify-content-end">
 <Button
 variant="primary"
 type="submit"
 disabled={isSubmitting || rating === 0}
 size="sm"
 >
 {isSubmitting ? (
 <>
 <span className="spinner-border spinner-border-sm me-1" />
 Đang gửi...
 </>
 ) : (
 'Gửi đánh giá'
 )}
 </Button>
 </div>
 </Form>
 </Modal.Body>
 </Modal>
 );
};

export default SoftwareRatingModal;

